
const phoneLoaded=(newBooks)=>{
    return {
        type: 'phone_loaded',
        payload: newBooks
    }
}

const addPrice=(price)=>{
    return{
        type: 'add_price',
        price: price
    }
}

const addProduct=(product)=>{
    return{
        type: 'add_product',
        product: product
    }
}
const addLoading=(loading)=>{
    return{
        type: 'loading',
        loading
    }
}
const addError=(error)=>{
    return{
        type: 'error',
        error,
    }
}
const minusCart=(id)=>{
    return{
        type: 'minus_cart',
        id,
    }
}
const plusCart=(id)=>{
    return{
        type: 'plus_cart',
        id,
    }
}
const deleteCart=(id)=>{
    return{
        type: 'delete_cart',
        id,
    }
}
export {
    phoneLoaded,
    addPrice,
    addProduct,
    addLoading,
    addError,
    minusCart,
    plusCart,
    deleteCart,

    
}